import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { ytWatch } from '../mock';

const YoutubeDialog = ({ video, onClose }) => (
  <Dialog open={!!video} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="border-white/10 bg-ink p-0 text-neutral-200 sm:max-w-3xl">
      <DialogTitle className="sr-only">{video?.title || 'Video'}</DialogTitle>
      <DialogDescription className="sr-only">YouTube video player</DialogDescription>
      {video && (
        <div>
          <div className="relative aspect-video w-full overflow-hidden bg-black">
            <iframe
              src={`https://www.youtube.com/embed/${video.youtubeId}?autoplay=1&rel=0`}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="h-full w-full"
            />
          </div>
          <div className="flex flex-wrap items-center justify-between gap-4 px-6 py-5">
            <div>
              <p className="text-[9px] tracking-[0.35em] text-gold">{video.show || video.tag || 'VIDEO'}</p>
              <p className="mt-1 font-serif text-xl tracking-[0.06em] text-white">{video.title}</p>
            </div>
            <a
              href={ytWatch(video.youtubeId)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="youtube-dialog-watch-link"
              className="group inline-flex items-center gap-2 text-[10px] tracking-[0.3em] text-neutral-300 transition-colors duration-300 hover:text-gold"
            >
              WATCH ON YOUTUBE
              <ArrowUpRight
                size={13}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);

export default YoutubeDialog;
